
document.addEventListener('DOMContentLoaded', function() {
    // DOM Elements
    const widget = document.getElementById('streamer-widget');
    const collapseBtn = document.getElementById('collapse-btn');
    const widgetContent = document.getElementById('widget-content');
    const streamersContainer = document.getElementById('streamers-container');
    const streamEmbed = document.getElementById('stream-embed');
    const emptyState = document.getElementById('empty-state');
    const liveCountBadge = document.getElementById('live-count');
    
    // Widget state
    let isCollapsed = false;
    let lastFetchTime = 0;
    const FETCH_INTERVAL = 60000; // 1 minute
    let currentEmbeddedStream = null;
    let currentEmbeddedPlatform = null;
    
    // Device detection
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    // Function to toggle between expanded/collapsed states
    function toggleCollapse() {
        isCollapsed = !isCollapsed;
        if (isCollapsed) {
            widget.classList.add('widget-collapsed');
            widgetContent.classList.add('hidden');
            collapseBtn.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
                </svg>
            `;
        } else {
            widget.classList.remove('widget-collapsed');
            widgetContent.classList.remove('hidden');
            collapseBtn.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
            `;
        }
    }
    
    // Add click event to collapse button
    collapseBtn.addEventListener('click', toggleCollapse);
    
    // Function to format viewer count
    function formatViewerCount(count) {
        if (count >= 1000000) {
            return (count / 1000000).toFixed(1) + 'M';
        } else if (count >= 1000) {
            return (count / 1000).toFixed(1) + 'K';
        }
        return count;
    }
    
    // Function to format start time
    function formatStartTime(startedAt) {
        const startTime = new Date(startedAt);
        const now = new Date();
        const diffMs = now - startTime;
        const diffMins = Math.floor(diffMs / 60000);
        if (diffMins < 60) {
            return `${diffMins}min`;
        } else {
            const hours = Math.floor(diffMins / 60);
            return `${hours}h${diffMins % 60 > 0 ? ' ' + (diffMins % 60) + 'min' : ''}`;
        }
    }
    
    // Function to create stream embed
    function createStreamEmbed(streamer) {
        if (isMobile) return; // Don't create embed on mobile
    }
    
    // Function to close stream embed
    function closeStreamEmbed() {
        streamEmbed.style.display = 'none';
        currentEmbeddedStream = null;
        currentEmbeddedPlatform = null;
        const embedContent = document.querySelector('.embed-responsive');
        embedContent.innerHTML = '';
    }
    
    // Function to create streamer cards
    function createStreamerCard(streamer) {
        // Handle thumbnail for different platforms
        let thumbnailUrl;
        if (streamer.platform === 'youtube') {
            thumbnailUrl = streamer.thumbnail_url || 'https://placehold.co/320x180/ff0000/ffffff?text=YouTube';
        } else {
            thumbnailUrl = streamer.thumbnail_url ? 
                streamer.thumbnail_url.replace('{width}', '320').replace('{height}', '180') : 
                'https://placehold.co/320x180/6441a5/ffffff?text=Twitch';
        }
        
        const card = document.createElement('div');
        card.className = 'streamer-card bg-white rounded-lg shadow hover:shadow-xl transition-shadow duration-300';
        
        // Platform specific styles and links
        const platformClass = streamer.platform === 'youtube' ? 'bg-red-600' : 'bg-purple-600';
        const streamUrl = streamer.platform === 'youtube' 
            ? `https://youtube.com/watch?v=${streamer.videoId}` 
            : `https://twitch.tv/${streamer.username}`;
            
        // Platform icon (Twitch or YouTube)
        const platformIcon = streamer.platform === 'youtube' ? 
            '<svg class="h-4 w-4" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>' :
            '<svg class="h-4 w-4" fill="currentColor" viewBox="0 0 24 24"><path d="M11.64 5.93h1.43v4.28h-1.43m3.93-4.28H17v4.28h-1.43M7 2L3.43 5.57v12.86h4.28V22l3.58-3.57h2.85L20.57 12V2m-1.43 9.29l-2.85 2.85h-2.86l-2.5 2.5v-2.5H7.71V3.43h11.43z"/></svg>';
        
        card.innerHTML = `
            <a href="${streamUrl}" target="_blank" class="block">
                <div class="thumbnail-container">
                    <img src="${thumbnailUrl}" alt="${streamer.display_name}" class="w-full h-auto">
                    <div class="platform-icon ${platformClass}">
                        ${platformIcon}
                    </div>
                    <div class="viewers-badge">
                        <div class="pulse-dot"></div>
                        <span>${formatViewerCount(streamer.viewer_count || 0)}</span>
                    </div>
                    ${streamer.game_name ? `<div class="game-badge">${streamer.game_name}</div>` : ''}
                </div>
                <div class="p-3">
                    <div class="flex items-center justify-between mb-2">
                        <h4 class="font-bold text-gray-800 truncate">${streamer.display_name}</h4>
                        <span class="text-xs text-gray-500">${streamer.started_at ? formatStartTime(streamer.started_at) : ''}</span>
                    </div>
                    <p class="text-sm text-gray-600 truncate">${streamer.title || ''}</p>
                </div>
            </a>
        `;
        
        return card;
    }
    
    // Function to fetch streamer status
    async function fetchStreamers() {
        const currentTime = Date.now();
        // Check if the interval has passed since the last request
        if (currentTime - lastFetchTime < FETCH_INTERVAL && lastFetchTime !== 0) {
            return;
        }
        
        try {
            const response = await fetch('/api/getStreamStatus');
            const data = await response.json();
            
            // Update last request time
            lastFetchTime = currentTime;
            
            // Combine all live streamers from both platforms
            const allLiveStreamers = [];
            
            // Process Twitch streamers
            if (data.status.twitchStreamers && Array.isArray(data.status.twitchStreamers)) {
                const twitchStreamers = data.status.twitchStreamers
                    .filter(streamer => streamer.isLive)
                    .map(streamer => ({
                        ...streamer,
                        platform: 'twitch'
                    }));
                allLiveStreamers.push(...twitchStreamers);
            }
            
            // Process YouTube streamers
            if (data.status.youtubeStreamers && Array.isArray(data.status.youtubeStreamers)) {
                const youtubeStreamers = data.status.youtubeStreamers
                    .filter(streamer => streamer.isLive)
                    .map(streamer => ({
                        ...streamer,
                        platform: 'youtube'
                    }));
                allLiveStreamers.push(...youtubeStreamers);
            }
            
            // Update live count
            const totalLiveCount = allLiveStreamers.length;
            liveCountBadge.textContent = totalLiveCount;
            
            // Clear container
            streamersContainer.innerHTML = '';
            
            if (totalLiveCount > 0) {
                // If there are live streamers, hide the empty state
                emptyState.classList.add('hidden');
                streamersContainer.classList.remove('hidden');
                
                // Sort streamers by viewer count
                const sortedStreamers = [...allLiveStreamers].sort((a, b) => 
                    (b.viewer_count || 0) - (a.viewer_count || 0)
                );
                
                // Show all streamers instead of limiting to 3
                const streamersToShow = sortedStreamers;
                
                // Create and add cards
                streamersToShow.forEach(streamer => {
                    const card = createStreamerCard(streamer);
                    streamersContainer.appendChild(card);
                });
                
            } else {
                // Show empty state if no live streamers
                streamersContainer.classList.add('hidden');
                emptyState.classList.remove('hidden');
                closeStreamEmbed();
            }
            
        } catch (error) {
            console.error('Error fetching streamer data:', error);
            // Show empty state on error
            streamersContainer.classList.add('hidden');
            emptyState.classList.remove('hidden');
            closeStreamEmbed();
        }
    }
    
    // Fetch streamers on page load
    fetchStreamers();
    
    // Set up polling to update every minute
    setInterval(fetchStreamers, FETCH_INTERVAL);
    
    // Set initial state based on device
    if (isMobile) {
        // Start collapsed on mobile
        isCollapsed = true;
        widget.classList.add('widget-collapsed');
        widgetContent.classList.add('hidden');
        collapseBtn.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
            </svg>
        `;
    }
});